import { configureStore } from '@reduxjs/toolkit';
import { api } from './middleware';
import rootReducer from './rootReducer';
import { apiSlice } from "src/_api/apiSlice";
import { setCustomizationsState } from './entities/customizations';

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these action types
                ignoredActions: ['dialog/openConfirmDialog', 'tutorial/setJoyrideCallback'],
                // Ignore these paths in the state
                ignoredPaths: [
                    'entities.confirmationDialog.onConfirm',
                    'entities.confirmationDialog.onClose',
                    'entities.tutorial.joyrideCallback'
                ],
            },
        }).concat(apiSlice.middleware, api),
});

const serializedState = localStorage.getItem('customizations');
if (serializedState !== null) {
    const customizations = JSON.parse(serializedState);
    store.dispatch(setCustomizationsState(customizations))
}

// Custom listeners: refetchOnFocus only after tab hidden for 5+ minutes,
// refetchOnReconnect fires immediately (same as default setupListeners)
const REFETCH_DELAY = 4 * 60 * 1000;
let lastHiddenAt = null;

window.addEventListener('online', () => store.dispatch(apiSlice.internalActions.onOnline()));
window.addEventListener('offline', () => store.dispatch(apiSlice.internalActions.onOffline()));
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
        lastHiddenAt = Date.now();
    } else if (document.visibilityState === 'visible') {
        if (lastHiddenAt && (Date.now() - lastHiddenAt) >= REFETCH_DELAY) {
            store.dispatch(apiSlice.internalActions.onFocus());
        }
        lastHiddenAt = null;
    }
});

export default store;